module.exports = __webpack_public_path__ + "img/header.c6dbd0e.jpg";